import React, { Component } from "react";
import { Button, Spinner, Toast } from "react-bootstrap-v5";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { toast } from "react-toastify";

import SimpleReactValidator from "simple-react-validator";
import JobService from "../../../Services/JobService";
import { paymmentInformation } from "../../../Function/defaultJobOptions";

import QuickInfo from "./JobForms/QuickInfo";
import Customerinfo from "./JobForms/CustomerInfo";
import Receiverinfo from "./JobForms/ReceiverInfo";
import Shipment from "./JobForms/Shipment";
import Schedule from "./JobForms/Schedule";
import Carrier from "./JobForms/Carrier";
import AddOns from "./JobForms/AddOns";
import Cargo from "./JobForms/Cargo";
import RevenueAndCost from "./JobForms/RevenueAndCost";
import QuoteBreakedown from "./JobForms/QuoteBreakedown";
// import Cost from './JobForms/Cost'
import Documents from './JobForms/Documents'
import Retailer from './JobForms/Retailer'
import Loader from "../../../Components/Loader";
import CourierPartner from "./JobForms/CourierPartner";
// import CheckAccess from '../../../Function/CheckAccess';
// import Quotation from './Quotation'

const tabWidth = {
  width: "84%",
};

class EditJobCart extends Component {
  constructor() {
    super();
    this.validator = new SimpleReactValidator();

    this.state = {
      buttonSubmit: true,
      validationToast: false,
      errorMsgs: [],
      jobData: {},
      removeBookingCount: 0,
      originData: {},
      destinationData: {},
      bookingAmount: 0,
      jobFinancialStatus: false,
      isDraftedInvoice: false,
      isDraftedCost: false,
      loading : false
    //   isview: null,
    };
  }

  componentDidMount() {
    //   const viewaccess = query.get("isedit");
    //   this.setState({ isEdit: viewaccess });
      this.setState({ loading : true })
      const query = new URLSearchParams(this.props.location.search);
      const jid = query.get("id");
      JobService.getJobDetails({ job_id: jid }).then((result) => {
      if (result.status === true) {
        let newStateData = result.data;
        let oData, dData;
        this.setState({
          jobFinancialStatus: result.data.is_financially_open,
        });

        //------ Set Origin and desination data for full address--------START---
        if (!newStateData.customer_details.mobile_number) {
          if (
            newStateData.user_detail &&
            newStateData.user_detail.length > 0 &&
            newStateData.user_detail[0].user_phone_number
          ) {
            newStateData.customer_details.mobile_number =
              newStateData.user_detail[0].user_phone_number;
          }
        }

        this.getPlaceData(newStateData.shipment_details.origin).then((e) => {
          oData = {
            origin_country: e.country,
            origin_country_short_name: e.country_short_name,
            origin_city: e.city,
            origin_latitude: e.latitude,
            origin_longitude: e.longitude,
          };
          this.setState(() => {
            return { originData: oData };
          });
        });

        this.getPlaceData(newStateData.shipment_details.destination).then(
          (e) => {
            dData = {
              origin_country: e.country,
              origin_country_short_name: e.country_short_name,
              origin_city: e.city,
              origin_latitude: e.latitude,
              origin_longitude: e.longitude,
            };

            this.setState(() => {
              return { destinationData: dData };
            });
          }
        );

        //------ Set Origin and desination data for full address--------END---

        if (!newStateData.hasOwnProperty("carrier_details")) {
          newStateData.carrier_details = {
            m_awb_m_b_l: "",
            m_awb_h_b_l: "",
            carrier_name: "",
            port_of_entry: "",
            shipment_type: "",
            comments: "",
          };
        }

        if (!newStateData.hasOwnProperty("payment_information")) {
          newStateData.payment_information = paymmentInformation();
        }

        if (!newStateData.hasOwnProperty("schedule_pickup")) {
          newStateData.schedule_pickup = {
            comments: "",
            pickup: [
              {
                pickup_shipment: "",
                salutation: "",
                sender_name: "",
                pickup_contact: "",
                pickup_date: "",
                pickup_time: "",
                address: "",
                email: "",
                delevered_by: "",
                invoice_no: "",
              },
            ],
          };
        }

        if (!newStateData.hasOwnProperty("document")) {
          newStateData.document = {
            customer_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
            store_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
          };
        }

        if (
          !newStateData.hasOwnProperty("retailer_details") ||
          Object.keys(newStateData.retailer_details).length === 0
        ) {
          newStateData.retailer_details = [];
        }
        this.setState(
          {
            jobData: newStateData,
            removeBookingCount: newStateData.quote_request_items.length,
            loading : false
          },
          () => {
            this.setBookingAmount();
          }
        );
      }
    });
  }

  setBookingAmount = () => {
    const {
      quote_request_airs,
      quote_request_couriers,
      quote_request_lands,
      quote_request_seas,
      shipment_details,
      payment_information,
    } = this.state.jobData;

    if (
      Object.keys(quote_request_airs).length === 0 &&
      Object.keys(quote_request_couriers).length === 0 &&
      Object.keys(quote_request_lands).length === 0 &&
      Object.keys(quote_request_seas).length === 0
    ) {
      this.setState({ bookingAmount: payment_information.booking_amount });
      return false;
    }

    let getFinalQuotezKey;

    let sType = shipment_details.hasOwnProperty("servic_type")
      ? shipment_details.servic_type
      : shipment_details.service_type;

    if (sType.includes("PORT")) getFinalQuotezKey = "port_delivery";
    if (sType.includes("DOOR")) getFinalQuotezKey = "door_delivery";
    if (sType.includes("CONSOLIDATION"))
      getFinalQuotezKey = "consolidation_delivery";
    if (sType.includes("OTHER")) getFinalQuotezKey = 'other_delivery'

    let bAmt = 0;
    let k = getFinalQuotezKey?.replace("_delivery", "");

    if (sType.includes("AIR")) {
      bAmt =
        quote_request_airs?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    } else if (sType.includes("COURIER")) {
      bAmt =
        quote_request_couriers?.final.door_delivery?.discount_door_grant_total;
    } else if (sType.includes("SEA")) {
      bAmt =
        quote_request_seas?.final[getFinalQuotezKey] &&
        quote_request_seas?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    } else if (sType.includes("LAND")) {
      bAmt =
        quote_request_lands?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    }

    this.setState({ bookingAmount: bAmt });
  };

  handleChangeValue = (event, objKey, objInnerKey = "") => {
    let fieldKey = objInnerKey != "" ? objInnerKey : event.target.name;
    let fieldValue =
      event.value == undefined ? event.target.value : event.value;
    let jobCardData = this.state.jobData;

    if (
      fieldKey === "quote_request_items" ||
      fieldKey === "retailer_details" ||
      fieldKey === "is_job_open" ||
      fieldKey === "general_details" ||
      fieldKey === "deliverer"
    ) {
      jobCardData[objKey] = fieldValue;
      this.setState(jobCardData);
    } else if (fieldKey === "insurance" || fieldKey === "storage") {
      jobCardData[objKey][fieldKey][event.name] = fieldValue;
      this.setState(jobCardData);
    } else {
      jobCardData[objKey][fieldKey] = fieldValue;
      if(fieldKey == 'insurance_opted' && fieldValue == 'no'){
       delete jobCardData[objKey]['insurance_applied'];
       delete jobCardData[objKey]['insurance_policy_received'] ;
      }else if(fieldKey == 'insurance_applied' && fieldValue == 'no'){
        delete jobCardData[objKey]['insurance_policy_received'] ;
      }
    }
    this.setState(jobCardData);
  };


  // handleSelect = (event, objKey, objInnerKey, index = null) => {
  //   console.log(event, "event");
  //   console.log(objKey, "objKey");
  //   console.log(objInnerKey, "objInnerKey");
  //   console.log(index, "index");
  
  //   let fieldKey = objInnerKey ? objInnerKey : event.target.name;
  //   let fieldValue = event.value !== undefined ? event.value : event.target.value;
  
  //   this.setState((prevState) => {
  //     let jobCardData = { ...prevState.jobData }; // Copy state to avoid mutation
  
  //     if (fieldKey === "shpt_receipt_assorment") {
  //       if (index !== null) {
  //         console.log(jobCardData[objKey], "jobCardData")
  //         jobCardData[objKey] = [...jobCardData[objKey]]; // Copy array
  //         jobCardData[objKey][index] = {
  //           ...jobCardData[objKey][index],
  //           [fieldKey]: fieldValue,
  //         };
  //       }
  //     } else if (fieldKey === "insurance" || fieldKey === "storage") {
  //       jobCardData[objKey] = { ...jobCardData[objKey] }; // Copy object
  //       jobCardData[objKey][fieldKey] = {
  //         ...jobCardData[objKey][fieldKey],
  //         [event.name]: fieldValue,
  //       };
  //     } else {
  //       jobCardData[objKey] = { ...jobCardData[objKey] }; // Copy object
  //       jobCardData[objKey][fieldKey] = fieldValue;
  
  //       if (fieldKey === "insurance_opted" && fieldValue === "no") {
  //         delete jobCardData[objKey]["insurance_applied"];
  //         delete jobCardData[objKey]["insurance_policy_received"];
  //       } else if (fieldKey === "insurance_applied" && fieldValue === "no") {
  //         delete jobCardData[objKey]["insurance_policy_received"];
  //       }
  //     }
  
  //     return { jobData: jobCardData }; // Return updated state
  //   });
  // };
  

  handleSelect = (event, objKey, objInnerKey, index = null) => {
  
    const fieldKey = objInnerKey || event.target?.name;
    const fieldValue = event?.value !== undefined ? event.value : event.target?.value;
  
    this.setState((prevState) => {
      const jobCardData = { ...prevState.jobData };
  
      if (fieldKey === "shpt_receipt_assorment" && index !== null) {
        // Target: jobCardData[objKey].pickup[index][fieldKey]
        const existingSection = { ...(jobCardData[objKey] || {}) };
        const pickupArray = [...(existingSection.pickup || [])];
  
        pickupArray[index] = {
          ...pickupArray[index],
          [fieldKey]: fieldValue,
        };
  
        jobCardData[objKey] = {
          ...existingSection,
          pickup: pickupArray,
        };
      } else if (fieldKey === "insurance" || fieldKey === "storage") {
        jobCardData[objKey] = {
          ...jobCardData[objKey],
          [fieldKey]: {
            ...(jobCardData[objKey]?.[fieldKey] || {}),
            [event.name]: fieldValue,
          },
        };
      } else {
        jobCardData[objKey] = {
          ...jobCardData[objKey],
          [fieldKey]: fieldValue,
        };
  
        if (fieldKey === "insurance_opted" && fieldValue === "no") {
          delete jobCardData[objKey]["insurance_applied"];
          delete jobCardData[objKey]["insurance_policy_received"];
        } else if (fieldKey === "insurance_applied" && fieldValue === "no") {
          delete jobCardData[objKey]["insurance_policy_received"];
        }
      }
  
      return { jobData: jobCardData };
    });
  };
  
  
  
  
  
  

  resetAddOnPayment = () => {
    let jobCardData = this.state.jobData;
    jobCardData.payment_information = paymmentInformation();
    jobCardData.add_ons.insurance = {
      insurance_amount: 0,
      insurance_premium: 0,
      items_goods: 0,
      minimum_aed: 0,
    };

    jobCardData.add_ons.storage = {
      handling_in: 0,
      handling_out: 0,
      minimum: 0,
      storage_amount: 0,
      storage_charges: 0,
      storage_value: 0,
    };
    this.setState(jobCardData);
  };

  getPlaceData = (address) => {
    return geocodeByAddress(address).then((results) => {
      const contrypick = results[0].address_components.filter(
        (item) => item.types.indexOf("country") >= 0
      );
      const citypick = results[0].address_components.filter(
        (item) =>
          item.types.indexOf("locality") >= 0 ||
          item.types.indexOf("administrative_area_level_1") >= 0
      );

      return getLatLng(results[0]).then((latlngRes) => {
        let pl = {
          country: contrypick[0]?.long_name,
          country_short_name: contrypick[0].short_name,
          city: citypick[0]?.long_name,
          latitude: latlngRes.lat,
          longitude: latlngRes.lng,
        };

        return pl;
      });
    });
  };

  handleChangeOriginDestination = (type, data) => {
    this.setState({ [type]: data });
  };

  handleOringDestination = (e, objKey) => {
    let jobCardData = this.state.jobData;
    jobCardData[objKey] = { ...jobCardData[objKey], ...e };
    this.setState(jobCardData);
  };

  validateCargoFields = (paramdata) => {
    let invalidFields = paramdata.filter((item1) => {
      return (
        Number(item1.actual.no_of_pkgs) === 0 ||
        Number(item1.actual.no_of_pkgs) === "" ||
        item1.actual.item_description === "" ||
        Number(item1.actual.height) === 0 ||
        item1.actual.height === "" ||
        Number(item1.actual.width) === 0 ||
        item1.actual.width === "" ||
        Number(item1.actual.length) === 0 ||
        item1.actual.length === "" ||
        Number(item1.actual.kilogram) === 0 ||
        item1.actual.kilogram === "" ||
        Number(item1.booking.no_of_pkgs) === 0 ||
        Number(item1.booking.no_of_pkgs) === "" ||
        item1.booking.item_description === "" ||
        Number(item1.booking.height) === 0 ||
        item1.booking.height === "" ||
        Number(item1.booking.width) === 0 ||
        item1.booking.width === "" ||
        Number(item1.booking.length) === 0 ||
        item1.booking.length === "" ||
        Number(item1.booking.kilogram) === 0 ||
        item1.booking.kilogram === ""
      );
    });
    if (paramdata.length === 1 && invalidFields.length === 1) {
      return false;
    } else {
      return invalidFields.length > 0;
    }
  };


  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ buttonSubmit: false });
    if (this.validator.allValid()) {
      let postData = this.state.jobData;
      postData.receiver_details.consignee =
        postData.receiver_details.receiver_name;
      postData.job_id = this.state.jobData._id;
      if (this.validateCargoFields(postData.quote_request_items)) {
        toast.error("Please fill cargo required fields");
        this.setState({ buttonSubmit: true });
        return false;
      }
      JobService.updateJobservice(postData).then((result) => {
        if (result.status === true) {
          toast.success(result.message);
          this.props.history.push("/job-list");
        }
      });
      this.setState({ buttonSubmit: true });
    } else {
      this.setState({ validationToast: true });
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      this.setState({ buttonSubmit: true });
    }
  };

  closeFinancially = async () => {
      let payload = {
      status: false,
      job_token: this.state.jobData.job_token,
    };
    await JobService.closeFinancialStatus(payload)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          this.props.history.push("/job-list");
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    const { jobData, buttonSubmit, validationToast, errorMsgs, loading } = this.state;
    if (!jobData || Object.keys(jobData).length === 0) return false;

    return (
      <>
        <form className="control-form" onSubmit={this.onSubmit}>
        <Loader isShow={this.state.loading}  />
          <QuickInfo
            onChangeValue={this.handleChangeValue}
            jobId={jobData._id}
            jobCustData={jobData.customer_details}
            jobShipmentData={jobData.shipment_details}
            jobToken={jobData.job_token}
            isJobOpen={jobData.is_job_open}
            paymentInformation={jobData.payment_information}
            generalDetails={jobData.general_details}
            userDetails={jobData.user_detail}
            jobData={jobData}
            formValidator={this.validator}
            stateData={this.state}
          />

          <div className="d-flex align-items-start">
            <div
              className="nav flex-column nav-pills me-3 bg-white"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                className="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type="button"
                role="tab"
                aria-selected="true"
              >
                Customer Info
              </button>

              <button
                className="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Receiver Info
              </button>

              <button
                className="nav-link"
                id="v-pills-shipment-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-shipment"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Shipment Summary
              </button>

              <button
                className="nav-link"
                id="v-pills-cargo-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-cargo"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Cargo Details
              </button>

              <button
                className="nav-link"
                id="v-pills-addons-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-addons"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Add Ons
              </button>

              <button
                className="nav-link"
                id="v-pills-schedule-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-schedule"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Schedule Pickup
              </button>

              <button
                className="nav-link"
                id="v-pills-carrier-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-carrier"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Carrier Details
              </button>

              <button
                className="nav-link"
                id="v-pills-revenue-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-revenue"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Revenue And Cost
              </button>

              {/* <button className="nav-link" id="v-pills-cost-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cost" type="button" role="tab" aria-selected="false">Cost</button> */}

              <button
                className="nav-link"
                id="v-pills-document-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-document"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Documents
              </button>

              <button
                className="nav-link"
                id="v-pills-retailer-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-retailer"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Retailer
              </button>
              <button
                className="nav-link"
                id="v-pills-quote-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-quote"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Quote Breakdown
              </button>
              {jobData.added_by.quote_by === "MARKETPLACE" && 
                <button
                  className="nav-link"
                  id="v-pills-quote-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-courier-partner"
                  type="button"
                  role="tab"
                  aria-selected="false"
                >
                  Courier Partners
                </button>
              }
            </div>

            <div
              className="tab-content"
              id="v-pills-tabContent"
              style={tabWidth}
            >
              <div
                className="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <Customerinfo
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.customer_details}
                  userData={jobData.user_detail}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <Receiverinfo
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.receiver_details}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-shipment"
                role="tabpanel"
                aria-labelledby="v-pills-shipment-tab"
              >
                <Shipment
                  onChangeValue={this.handleChangeValue}
                  handleResetAddOnPayment={this.resetAddOnPayment}
                  jobData={jobData.shipment_details}
                  jobItems={jobData.quote_request_items}
                  quoteToken={jobData.quote_token}
                  paymentInformation={jobData.payment_information}
                  handleChangeOrgDest={this.handleChangeOriginDestination}
                  formValidator={this.validator}
                  handleOringDestination={this.handleOringDestination}
                  isview={this.state.isview}
                  handleSelect={this.handleSelect}
                  schedulePickup={jobData.schedule_pickup}
                  orderId={jobData?.mk_order_id}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-schedule"
                role="tabpanel"
                aria-labelledby="v-pills-schedule-tab"
              >
                <Schedule
                  isview={this.state.isview}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.schedule_pickup}
                  totalJobData={jobData}
                  jobToken={jobData.job_token}
                  quoteToken={jobData.quote_token}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-carrier"
                role="tabpanel"
                aria-labelledby="v-pills-carrier-tab"
              >
                <Carrier
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.carrier_details}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-addons"
                role="tabpanel"
                aria-labelledby="v-pills-addons-tab"
              >
                <AddOns
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.quote_request_items}
                  addOns={jobData.add_ons}
                  jobCargoData={jobData.cargo_details}
                  jobShipmentData={jobData.shipment_details}
                  generalDetails={jobData.general_details}
                  quoteToken={jobData.quote_token}
                  originData={this.state.originData}
                  destinationData={this.state.destinationData}
                  paymentInformation={jobData.payment_information}
                  prevItemCount={this.state.removeBookingCount}
                  itemsBookingAmount={this.state.bookingAmount}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-cargo"
                role="tabpanel"
                aria-labelledby="v-pills-cargo-tab"
              >
                <Cargo
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.quote_request_items}
                  removeBookingCount={this.state.removeBookingCount}
                  jobShipmentData={jobData.shipment_details}
                  jobCargoData={jobData.cargo_details}
                  quoteToken={jobData.quote_token}
                  originData={this.state.originData}
                  destinationData={this.state.destinationData}
                  paymentInformation={jobData.payment_information}
                  formValidator={this.validator}
                  isEdit={this.state.isEdit}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-revenue"
                role="tabpanel"
                aria-labelledby="v-pills-revenue-tab"
              >
                <RevenueAndCost
                  // isInvoice={this.state.isInvoice}
                //   isEdit={this.state.isEdit}
                  checkInvoice={(draft) => {
                    this.setState({
                      isDraftedInvoice: draft,
                    });
                  }}
                  checkCost={(draft) => {
                    this.setState({
                      isDraftedCost: draft,
                    });
                  }}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.retailer_details}
                  bookingData={jobData}
                  jobStatus={jobData.job_status}
                  customerData={jobData.customer_details}
                  receiverData={jobData.receiver_details}
                  quoteToken={jobData.job_token}
                  carrierData={jobData.carrier_details}
                  payInfoData={jobData.payment_information}
                  jobId={jobData._id}
                  jobToken={jobData.job_token}
                  formValidator={this.validator}
                />
              </div>

              {/* <div className="tab-pane fade" id="v-pills-cost" role="tabpanel" aria-labelledby="v-pills-cost-tab">
                                <Cost 
                                    onChangeValue={this.handleChangeValue}
                                    jobData={jobData.retailer_details}
                                    customerData={jobData.customer_details}
                                    jobId={jobData._id}
                                    formValidator={this.validator} 
                                />
                            </div> */}

              <div
                className="tab-pane fade"
                id="v-pills-document"
                role="tabpanel"
                aria-labelledby="v-pills-document-tab"
              >
                <Documents
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-retailer"
                role="tabpanel"
                aria-labelledby="v-pills-retailer-tab"
              >
                <Retailer
                //   isview={this.state.isview}
                  onChangeValue={this.handleChangeValue}
                  // jobData={jobData.retailer_details}
                  jobId={jobData._id}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-quote"
                role="tabpanel"
                aria-labelledby="v-pills-quote-tab"
              >
                <QuoteBreakedown
                //   isview={this.state.isview}
                  // onChangeValue={this.handleChangeValue}
                  jobData={jobData}
                  shipmentDetails={jobData.shipment_details}
                  // formValidator={this.validator}
                />
              </div>

                {jobData.added_by.quote_by === "MARKETPLACE" && 
                <div
                  className="tab-pane fade"
                  id="v-pills-courier-partner"
                  role="tabpanel"
                  aria-labelledby="v-pills-quote-tab"
                >
                  <CourierPartner
                    jobData={jobData}
                    itemList={jobData.quote_request_items}
                    pickupList={jobData.schedule_pickup.pickup}
                    job_token={jobData.job_token}
                    receiver_details={jobData.receiver_details}
                    disabled={false}
                  />
                </div>
                }
            </div>
          </div>

          {/* {this.state.isview && ( */}
            <div className="row">
              <div className="col-2"></div>
              <div className="col-4">
                {buttonSubmit && (
                  <Button type="submit" variant="primary" size="lg">
                    Submit
                  </Button>
                )}

                {!buttonSubmit && (
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </Button>
                )}

                {
                  <Toast
                    className="d-inline-block m-1 bg-danger"
                    onClose={() => this.setState({ validationToast: false })}
                    show={validationToast} /* delay={3000} */
                  >
                    <Toast.Header>
                      <strong className="me-auto">Errors</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">
                      {Object.keys(this.validator.getErrorMessages()).map(
                        (key,i) => {
                          return (
                            <p key={i}>{this.validator.getErrorMessages()[key]}</p>
                          );
                        }
                      )}
                    </Toast.Body>
                  </Toast>
                }
              </div>
              {this.state.jobFinancialStatus &&
                !this.state.isDraftedInvoice &&
                !this.state.isDraftedCost && (
                  <div className="col-5 d-flex justify-content-end">
                    <Button type="button" variant="primary" size="lg" onClick={this.closeFinancially} >
                      Close Financially
                    </Button>
                  </div>
                )}

              {/* <div className="col-6"> */}
              {/* <Quotation
                                jobItems={jobData.quote_request_items}
                                jobShipmentData={jobData.shipment_details}
                                jobCargoData={jobData.cargo_details}
                                quoteToken={jobData.quote_token}
                                originData={this.state.originData}
                                destinationData={this.state.destinationData}
                            /> */}
              {/* </div> */}
            </div>
          {/* )} */}
        </form>
      </>
    );
  }
}

export { EditJobCart };

